export default __webpack_public_path__ + "static/aboutYou-d4dff5d1065b7b699f4286cb575b86fd.webp";